import React from 'react'
import checkPermission from '../../../../../utilities/checkPermission'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import { DialogType } from '../../../../../control/dialog/dialog'
import useLoading from '../../../../../control/loading/useLoading'
import useWebService from '../../../../../services/web/useWebService'
import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'
import authenStore from '../../../../../stores/authen/authenStore'
import useTranslate from '../../../../../i18n/useTranslate'
import SecretCodeForm from '../../../shareUI/secretCodeForm/secretCodeForm'
import { useHistory } from 'react-router-dom'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'

// --- Contants --- //

import { SignRepresentREC1Type } from './signRepresentREC1'
import { encryption } from '../../../../../utilities/encryption'
import { cerTopic } from '../../../../../constants/constants'
import { certificateInfoType } from '../../../../../services/web/types/responseWebServiceTypes'

type CerDialogType = Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>
const useSignRepresent = (props: SignRepresentREC1Type) => {
    const { callbackSaveComplete } = props
    const [initialValues, setInitialValues] = React.useState<any>({})
    const manageProjectStore = useManageProjectStore()
    const { projectData } = manageProjectStore
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const [configDialog, setConfigDialog] = React.useState<CerDialogType>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const loadingHook = useLoading()
    const callWebService = useWebService()
    const profileStore = authenStore()
    const { profile } = profileStore
    const translate = useTranslate()
    const history = useHistory()
    const statusAfterClose = React.useRef<string>('save')
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const { tabSelected } = appFolderAndTabStore
    const [initialUploadFileCer, setInitialUploadFileCer] = React.useState<any>()

    React.useEffect(() => {
        createInitialData()
        // if (projectData?.irb && projectData?.submitTypeInfo?.value) {
        //     getCertificate()
        // }
    }, [])

    const createInitialData = async () => {
        if (projectData) {
            const submittedID = projectData.submittedID
            const projectID = projectData.projectID
            loadingHook.loadingOpen()
            const { result, status } = await callWebService.getSignCertificate(projectID, submittedID)
            loadingHook.loadingClose()
            if (status === 1) {
                const initialData = {
                    chairmanSign: result.isSignBeHalfPresident,
                    secretarySign: result.isSignBeHalfSecretary,
                }
                const initialFileValue = createInitialFile(result.certificateInfo)
                setInitialValues(initialData)
                setInitialUploadFileCer(initialFileValue)
            }
        }
    }

    const createInitialFile = (certificateInfo: certificateInfoType) => {
        const uploadFileinitCer = cerTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })

        // const certificateInfo = result.certificateInfo
        uploadFileinitCer.forEach((itm: any) => {
            if (itm.uploadFileObj.documentTopicID === 1) {
                if (certificateInfo?.certificateSignFileName_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: certificateInfo?.certificateSignFileName_en,
                        filename: certificateInfo?.certificateSignFileName_en,
                        fileID: certificateInfo?.certificateSignFileName_en,
                        path: certificateInfo?.cerSign_en,
                    }

                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            } else if (itm.uploadFileObj.documentTopicID === 0) {
                if (certificateInfo?.certificateSignFileName_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: certificateInfo?.certificateSignFileName_th,
                        filename: certificateInfo?.certificateSignFileName_th,
                        fileID: certificateInfo?.certificateSignFileName_th,
                        path: certificateInfo?.cerSign_th,
                    }

                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            }
        })
        return uploadFileinitCer
        // setInitialUploadFileCer(uploadFileinitCer)
    }

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    const handleDirtyChange = (props: { dirty: boolean }) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }
    const handleSubmitForm = async (val: any) => {
        const signBehalfCertificateRequest: REQServiceType.SignCertificateType = {
            projectID: projectData?.projectID || null,
            signUserID: profileStore.profile.userId,
            submittedID: projectData?.submittedID || null,
            isSignBehalfPresident: val?.chairmanSign,
            isSignBehalfSecretary: val?.secretarySign,
            signUserPinCode: null,
        }
        if (val.saveType === 'SAVE') {
            setConfigDialog({
                title: translate.get('LABEL.SECRET_PASSWORD'),
                content: React.createElement(SecretCodeForm, {
                    onClickClose: () => {
                        dialogRef.current?.closeDialog()
                    },
                    onClickSave: (val: any) => {
                        handleSubmitSecretCode({
                            ...signBehalfCertificateRequest,
                            signUserPinCode: encryption(val.password),
                        })
                    },
                }),
                type: '',
            })
            dialogRef.current?.openDialog()
        }
    }
    const handleSubmitSecretCode = async (paramForSave: any) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        const res = await callWebService.signCertificate(paramForSave)

        loadingHook.loadingClose()
        await conditionDialog(res?.status)
    }
    const conditionDialog = (status: number) => {
        if (status === 1) {
            if (status && callbackSaveComplete) {
                setDefaultPage()
                createInitialData()
                callbackSaveComplete(status, false)
            }
            // setConfigDialog({
            //     title: translate.get('ALERT.TITLE.NOTIFICATION'),
            //     content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
            //     type: 'alert-message',
            //     onAfterClose: () => {
            //         if (status && callbackSaveComplete) {
            //             setDefaultPage()
            //             callbackSaveComplete(status, false)
            //         }
            //     },
            // })
            // dialogRef.current?.openDialog()
        } else if (status === -2) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.SECRET_PASSWORD_INCORRECT'),
                type: 'alert-message',
            })
            dialogRef.current?.openDialog()
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
            dialogRef.current?.openDialog()
        }
    }

    const setDefaultPage = () => {
        setConfigDialog({}) //clear function dialog
        // loadLatestFolder()
        appFolderAndTabAction.resetTabDirty()
    }

    const getCerTopic = () => {
        let myCerTopic = cerTopic

        if (!projectData?.isLanguageEN) {
            //ตัดภาษาอังกฤษออก
            myCerTopic = cerTopic.filter((itm) => itm.id !== 1)
        }
        if (!projectData?.isLanguageTH) {
            //ตัดภาษาไทยออก
            myCerTopic = cerTopic.filter((itm) => itm.id !== 0)
        }
        return myCerTopic
    }

    return {
        onRefDialog,
        configDialog,
        isViewMode,
        initialValues,
        handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        initialUploadFileCer,
        certificateTopicList: getCerTopic(),
        projectData,
    }
}
export default useSignRepresent
